import Http from '../utils/http'
import store from 'store/index'

export const create = (payload) => Http.post('/deals', payload)

export const createWithLead = (payload) => Http.post('/deals-with-lead', payload)

export const update = (id, payload) => {
    return Http.put(`/deals/${id}`, payload)
        .then(response => store.dispatch('saveDeal', response.data))
}

export const perceptionUpdate = (id, perception) => {
    return Http.put(`/deals/${id}/${perception}`)
       .then(response => store.dispatch('saveDeal', response.data))
}

export const destroy = (id) => Http.delete(`/deals/${id}`)

export const get = (id) => Http.get(`/deals/${id}`)

export const getUnattendedDeals = (params = {}) => Http.get('/deals/unattended', { params })

export const getRaw = (id) => Http.get(`/deals-raw/${id}`)

export const getAllPaged = (page = 1, extraParams = {}) => Http.get('/deals', { params: { page, ...extraParams } })

export const getAll = (params = {}) => Http.get('/deals', { params })

export const getKanban = (id, params = {}) => Http.get(`/deals/pipelines/${id}`, { params })

export const sort = (params = {}) => Http.put(`/deals/sort`, params)

export const exportAll = (params = {}) => Http.get('/deals/export', { params })

export const transferAll = (payload) => Http.put('/deals/transfer', payload)

export const sold = (id, payload) => {
    return Http.put(`/deals/${id}/sold`, payload)
               .then(response => store.dispatch('setDeal', response.data))
}

export const cancel = (id, payload) => {
    return Http.put(`/deals/${id}/cancel`, payload)
               .then(response => store.dispatch('setDeal', response.data))
}

export const open = (id) => {
    return Http.put(`/deals/${id}/open`)
               .then(response => store.dispatch('setDeal', response.data))
}

export const getInterests = () => Http.get(`/deals/interests`)



// WEBPACK FOOTER //
// ./src/services/deals.js